export default "__VITE_ASSET__3936dcc0__"